module.exports = __webpack_public_path__ + "static/media/aplicacao.43548ca9.png";